import { subWeeks } from 'date-fns';

const getDateRangeFromNow = (period) => {
  const now = new Date();

  switch (period) {
    case 'lastWeek': {
      return {
        dateEnd: now,
        dateStart: subWeeks(now, 1),
      };
    }
    case 'nextWeek': {
      return {
        dateStart: now,
        dateEnd: subWeeks(now, -1),
      };
    }
    case 'week': {
      return {
        dateStart: subWeeks(now, 1),
        dateEnd: now,
      };
    }
    default:
      throw new Error("Can't match passed period");
  }
};

export default getDateRangeFromNow;
